export const reverseMappingTypes = {
  Edit: 0,
  Fill: 1,
  Filled: 2,
};
